import { useCallback } from 'react'

import { usePayNowStatus } from '@features/paynow/hooks/usePayNowStatus'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useOrganizationSource } from '../../../hooks'
import { getBankPaymentIds } from '../utils/getBankPaymentIds'
import { isStripeClearingPayment } from '../utils/isStripeClearingPayment'
import { useFetchBankPayments } from './useFetchBankPayments'

export const useCardPayments = (modifierReferences?: Array<string | null | undefined>) => {
  const { isLoading: isOrganizationLoading } = useUserOrganization()
  const { isSourceZervant } = useOrganizationSource()
  const bankPaymentIds = getBankPaymentIds(modifierReferences)
  const hasBankPayments = bankPaymentIds.length > 0
  const shouldDetectCardPayments = isSourceZervant && hasBankPayments
  const { isLoading: isPayNowStatusLoading, payNowStatus } = usePayNowStatus({
    enabled: shouldDetectCardPayments,
  })
  const { bankPaymentsById, isLoading: isBankPaymentsLoading } = useFetchBankPayments(
    shouldDetectCardPayments ? bankPaymentIds : [],
  )

  const isCardPayment = useCallback(
    (modifierReference?: string | null): boolean => {
      if (!shouldDetectCardPayments) {
        return false
      }

      const [bankPaymentId] = getBankPaymentIds([modifierReference])

      return isStripeClearingPayment(
        bankPaymentId ? bankPaymentsById[bankPaymentId]?.cashAccountId : undefined,
        payNowStatus?.clearingCashAccountId,
      )
    },
    [bankPaymentsById, payNowStatus?.clearingCashAccountId, shouldDetectCardPayments],
  )

  // Source is unknown while the organization is loading. Keep bank-paid rows in the loading
  // state until the source is known, so the label is final when the pane appears.
  const isAwaitingOrganizationSource = isOrganizationLoading && hasBankPayments
  const isLoading =
    isAwaitingOrganizationSource || (shouldDetectCardPayments && (isPayNowStatusLoading || isBankPaymentsLoading))

  return { isCardPayment, isLoading }
}
